// extracted by mini-css-extract-plugin
export default {"container":"Add_container__4yyyZ","box":"Add_box__GGiOx","btn_box":"Add_btn_box__K5hyh"};